/** The Registration Fee's status (2026-11-06). A student can be registered
 * while it is Not Paid — it stays outstanding until a payment is recorded
 * and approved by finance. */
export type RegistrationPaymentStatus = 'NOT_PAID' | 'PENDING_APPROVAL' | 'APPROVED' | 'REJECTED' | 'REVERSED';

export const REGISTRATION_PAYMENT_LABEL: Record<RegistrationPaymentStatus, string> = {
  NOT_PAID: 'Not Paid',
  PENDING_APPROVAL: 'Payment Pending Approval',
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
  REVERSED: 'Reversed',
};
